import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GetBucketFile, getJsonTagDetails } from "../../../Services/APIs/annotation";
import { useSwipeable } from "react-swipeable";
import Annotation from "../../Annotation/annotation";
import AnnotatedTags from "../../PeriGumCheck/ReportSummary/annotatedTags";

const ReportImages = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [normalImages, setNormalImages] = useState([])
    const [txtTags, setTxtTags] = useState([])
    const [jsonTags, setJsonTags] = useState([])
    const response = JSON.parse(localStorage.getItem("response"))
    console.log(response);
    const subFolderName = JSON.parse(localStorage.getItem("response")).folder_name.split('/')[1]
    const companyS3Bucket = response.bucket_name
    const [isPopupOpen, setPopup] = useState(false)
    const [isLoading, setLoading] = useState(true)

    const teethImages = [
        JSON.parse(localStorage.getItem("response"))?.front_teeth,
        JSON.parse(localStorage.getItem("response"))?.left_side,
        JSON.parse(localStorage.getItem("response"))?.right_side
    ];


    const upperJawImage = JSON.parse(localStorage.getItem("response"))?.upper_jaw || null;
    const lowerJawImage = JSON.parse(localStorage.getItem("response"))?.lower_jaw || null;
    if (upperJawImage) {
        teethImages.push(upperJawImage);
    }
    if (lowerJawImage) {
        teethImages.push(lowerJawImage);
    }

    useEffect(() => {
        getJson(setJsonTags)
        getImages(setNormalImages)
    }, [])

    const getJson = async (storage) => {
        await Promise.all(teethImages.filter(teeth => teeth).map(async (teeth, index) => {
            return await getJsonTagDetails(`input/${subFolderName}/${teeth}`).then((resData) => {
                if (resData.data.data !== "No Data") {
                    const imageName = teeth;
                    const jsonData = resData.data.data
                    storage(prevState => [...prevState, { imageName, jsonData }])
                    return { imageName, jsonData }
                } else {
                    getTxtTags(setTxtTags)
                }
            }).catch((err) => {
                getTxtTags(setTxtTags)

            })
        }))
    }

    const getImages = async (storage) => {
        await Promise.all(teethImages.filter(teeth => teeth).map(async (teeth, index) => {
            if (teeth) {
                const data = {
                    fileName: `${subFolderName}/${teeth}`,
                    fileFolder: `${companyS3Bucket}/input`,
                    uid: JSON.parse(localStorage.getItem('usertpi')).usertpi,
                    folderName: JSON.parse(localStorage.getItem("usertpi")).usertpi,
                    company: JSON.parse(localStorage.getItem("companyBucket")).companyBucket
                }

                return await GetBucketFile(data).then((resData) => {
                    if (resData.data.data !== "No Data") {
                        const byteArray = new Uint8Array(resData.data.data.data)
                        const blob = new Blob([byteArray], { type: 'image/jpeg' });
                        const imageName = teeth
                        const imageUrl = URL.createObjectURL(blob);
                        storage(prevState => [...prevState, { imageName, imageUrl }])
                        return { imageName, imageUrl }
                    }
                }).catch((err) => {
                })
            }
        }))
        setLoading(false)
        setTimeout(() => { // once all images loads, popup should open after 40 sec.
            setPopup(true)
        }, 40000)
    }

    const getTxtTags = async (storage) => {
        await Promise.all(teethImages.filter(teeth => teeth).map(async (teeth, index) => {
            const data = {
                fileName: `${subFolderName}_${teeth.split('.')[0]}.txt`,
                fileFolder: `${companyS3Bucket}/output`,
                uid: JSON.parse(localStorage.getItem('usertpi')).usertpi,
                folderName: JSON.parse(localStorage.getItem("usertpi")).usertpi,
                company: JSON.parse(localStorage.getItem("companyBucket")).companyBucket
            }
            return await GetBucketFile(data).then((tags) => {
                const imgTags = tags.data.data.split("\n")
                const imageName = teeth
                storage(prevState => [...prevState, { imageName, imgTags }])
            }).catch((err) => {
            })
        }))
    }

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const handleSwipedLeft = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % teethImages.length);
    };

    const handleSwipedRight = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + teethImages.length) % teethImages.length);
    };

    const swipeHandlers = useSwipeable({
        onSwipedLeft: handleSwipedLeft,
        onSwipedRight: handleSwipedRight,
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });




    return (
        <div className="rounded h-fit ">
            <div {...swipeHandlers} className="relative">
                {
                    isLoading ?
                        <div className="loader-container h-72">
                            <div className="loader dark-loader"></div>
                        </div> :

                        <AnnotatedTags
                            companyS3Bucket={companyS3Bucket}
                            jsonTags={jsonTags[jsonTags.findIndex(item => item.imageName == normalImages[currentIndex]?.imageName)]?.jsonData}
                            image={normalImages[currentIndex]}
                            texTags={txtTags[txtTags.findIndex(item => item.imageName == normalImages[currentIndex]?.imageName)]?.imgTags}
                        />

                }
            </div>
            <div className="flex justify-center my-8">
                {teethImages.map((_, index) => (
                    <button
                        key={index}
                        className={`w-3 h-3 mx-1 rounded-full ${index === currentIndex ? "bg-gray-900" : "bg-gray-400"}`}
                        onClick={() => goToSlide(index)}
                    ></button>
                ))}
            </div>
        </div>
    )
}

export default ReportImages